"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMediaCssObject = void 0;
const tokens_1 = require("../../styles/tokens");
const MEDIA_BREAKPOINTS = {
    xs: `@media (min-width: ${tokens_1.BREAKPOINTS.xs})`,
    sm: `@media (min-width: ${tokens_1.BREAKPOINTS.sm})`,
    md: `@media (min-width: ${tokens_1.BREAKPOINTS.md})`,
    lg: `@media (min-width: ${tokens_1.BREAKPOINTS.lg})`,
    xl: `@media (min-width: ${tokens_1.BREAKPOINTS.xl})`,
};
/**
 * Convert a string to it's values in pixels defined by SIZES
 * @param gapValue ie: "0.25", "2", "1.5 4"
 * @returns "2px", "16px", "12px 32px"
 */
const toPixelSIZES = (gapValue) => {
    const rowcols = gapValue.split(" ");
    return rowcols.length === 2
        ? `${tokens_1.SIZES[Number(rowcols[0])]} ${tokens_1.SIZES[Number(rowcols[1])]}`
        : `${tokens_1.SIZES[Number(rowcols[0])]}`;
};
/**
 * Convert a (FlexAllValues or MobileBreakpoints) to CssObject with media queries directly usable by styled components
 * @param cssRule ie: "flex-direction", "align-items"
 * @param breakpointsProps ie: "column" or {xs: "column", md: "row"}
 * @returns Corresponding CssObject for styled components
 * Example of returned CssObject from a FlexAllValues
 * {
 *      "flex-direction": "column"
 * }
 * Example of returned CssObject from a MobileBreakpoints<FlexAllValues>
 * {
 *      "@media (min-width: 0)": {
 *          "flex-direction": "column"
 *      }
 *      "@media (min-width: 768px)": {
 *          "flex-direction": "row"
 *      }
 * }
 */
const toMediaCssObject = (cssRule, breakpointsProps) => {
    if (typeof breakpointsProps === "string") {
        if (cssRule === "gap") {
            return { [cssRule]: toPixelSIZES(breakpointsProps) };
        }
        return { [cssRule]: breakpointsProps };
    }
    // When xs is omitted we take the smallest defined value
    const breakpointsPropsWithDefault = Object.assign({ xs: breakpointsProps.xs ||
            breakpointsProps.sm ||
            breakpointsProps.md ||
            breakpointsProps.lg ||
            breakpointsProps.xl }, breakpointsProps);
    // Loops throught breakpoints object ie: {"xs": "column", "lg": "row"}
    const mediaCssObject = {};
    Object.keys(breakpointsPropsWithDefault).forEach((breakpointStr) => {
        const breakpointKey = breakpointStr; // ie: "xs", "sm", "md"
        const cssMediaQuery = MEDIA_BREAKPOINTS[breakpointKey]; // ie: "@media (min-width: 576px)"
        const cssValue = breakpointsPropsWithDefault[breakpointKey] || ""; // ie: "column", "space-between"
        if (cssRule === "gap") {
            mediaCssObject[cssMediaQuery] = {
                [cssRule]: toPixelSIZES(cssValue),
            };
        }
        else {
            mediaCssObject[cssMediaQuery] = {
                [cssRule]: cssValue,
            };
        }
    });
    return mediaCssObject;
};
exports.toMediaCssObject = toMediaCssObject;
//# sourceMappingURL=Layout.helpers.js.map